import { openBlock as t, createElementBlock as c, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ e("path", { d: "M4 20.75a.75.75 0 0 1-.75-.75V4a.75.75 0 0 1 1.5 0v15.25H20a.75.75 0 0 1 0 1.5H4Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M11.03 4.25c-.64 0-1.133.312-1.485.743-.333.408-.558.94-.726 1.486-.294.952-.48 2.172-.658 3.351l-.076.499c-.213 1.376-.438 2.651-.818 3.58-.385.942-.802 1.25-1.274 1.255a.75.75 0 0 0 .014 1.5c1.41-.014 2.195-1.078 2.648-2.187.458-1.12.704-2.572.912-3.92l.078-.506c.182-1.2.349-2.293.607-3.13.147-.474.303-.792.455-.98.107-.13.19-.174.267-.187.025.024.067.07.124.156.154.231.32.606.495 1.129.324.973.614 2.266.924 3.645l.063.283c.327 1.456.679 2.985 1.11 4.183.214.598.463 1.156.764 1.595.291.426.708.849 1.292.969.573.117 1.089-.06 1.506-.362.401-.29.738-.712 1.023-1.172.572-.92 1.051-2.18 1.442-3.46a.75.75 0 0 0-1.434-.44c-.38 1.245-.815 2.356-1.282 3.109-.235.378-.45.618-.629.748-.164.119-.259.12-.325.107-.024-.005-.152-.05-.356-.347-.196-.285-.393-.706-.59-1.254-.393-1.095-.726-2.529-1.058-4.005l-.07-.31c-.302-1.349-.608-2.715-.957-3.764-.187-.56-.404-1.087-.67-1.486-.249-.373-.673-.828-1.315-.828Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  l,
  n
];
function d(a, s) {
  return t(), c("svg", o, [...r]);
}
const h = { render: d };
export {
  h as default,
  d as render
};
